<template>
  <v-dropdown
  ref="dropdown"
  @update:opened="ddChange"
  @open="onOpen"
  :opened="opened"
  class="">
    <template slot="display">
      <slot 
      :validated="validated"
      :display="display"
      :item="selectedItem"
      name="display">
        <v-input 
        class="floating-label full-width"
        ref="input"
        :hasReset="hasReset && validated"
        :class="{
          active: opened || validated
        }"
        :value="selectedItem[displayKey]"
        :placeholder="placeholder"
        :floatingLabel="floatingLabel"
        isReadOnly="true"
        @reset="reset">
        </v-input>
      </slot>
    </template>
    <div slot="content"
    class="scroll_container"
    :style="{
      height: ((loading)?49:Math.min(Math.max(items.length, 1), 4)*49)+'px'
    }">
      <v-list
      ref="list"
      @select="onSelect"
      :items="items">
        <template slot-scope="list">
          <tr
          :key="list.item[list.keyField]"
          class="item"
          :class="{
            active: list.item === list.item_activated,
            selected: list.item[idKey] == value
          }"
          >
          <td v-html="list.item[displayKey]"></td>
          </tr>
        </template>
      </v-list>
    </div>
  </v-dropdown>
</template>

<script>

export default {
  props: {
    display: {
      default: ''
    },
    value: {
      required: true
    },
    items: {
      required: true
    },
    placeholder: {
      default: ''
    },
    floatingLabel: {
      default: true
    },
    min_letters: {
      default: 0
    },
    hasReset: {
      default: true
    },
    idKey: {
      default: 'id'
    },
    displayKey: {
      default: 'n'
    },
    opened: {
      default: false
    }
  },
  data () {
    return {
      loading: false
    }
  },
  // watch: {
  //   opened: function (val) {
  //     console.log('opened changed', val)
  //   }
  // },
  computed: {
    validated: function () {
      return this.value > 0
    },
    itemObject: function () {
      let idKey = this.idKey
      let o = {}
      let id
      // console.log('this.items', this.items)
      this.items.forEach(function (item) {
        id = item[idKey]
        o[id] = item
      })
      return o
    },
    selectedItem: function () {
      let res = {}

      if (typeof this.itemObject[this.value] === 'undefined') {
        res[this.idKey] = 0
        res[this.displayKey] = ''
        return res
      }

      return this.itemObject[this.value]
    }
  },

  methods: {
    ddChange (val) {
      // console.log('ddChange', val)
      this.refresh()
      this.$emit('update:opened', val)
    },

    onOpen () {
      var vm = this
      // this.opened = true
      this.$nextTick(function () {
        this.$emit('open')
        this.refresh()
      })
    },

    onClose () {
      // this.opened = false
      // this.$emit('close')
    },

    refresh () {
      var vm = this
      this.$nextTick(function () {
        if (this.$refs.list) {
          this.$refs.list.resize()
        }
      })
    },

    open () {
      // this.$refs.dropdown.open()
      this.$emit('update:opened', true)
    },

    close () {
      // this.$refs.dropdown.close()
      this.$emit('update:opened', false)
    },

    isLoading () {
      this.loading = true
    },

    isLoaded () {
      this.loading = false
    },

    onSelect (item) {
      var vm = this
      // this.validated = true
      vm.$emit('input', item[this.idKey], item)
      this.$emit('update:opened', false)
      // this.$nextTick(function () {
      //   this.close()
      // })
    },

    onFocus (e) {
      var vm = this
      setTimeout(function () {
        vm.$emit('focus', e)
      })
    },

    reset: function () {
      // let res = {}
      this.$refs.list.ScrollToTop()
      this.$emit('input', 0, {
        id: 0,
        n: ''
      })
    },

    resize: function () {
      if (this.$refs.list) {
        this.$refs.list.ScrollToTop()
        this.$nextTick(function () {
          this.$refs.list.resize()
          // cons
        })
      }
    }
  },

  mounted () {
    // this.validated = this.id > 0
    // console.log('this.items', this.items)
    // console.log('this.model', this.model)
  }

}
</script>
<style>
/*.dd-select*/
/*.active*/
</style>
